<template>
  <div class="client-selection d-flex align-items-center gap-2">
    <treeselect id="clientSelector"
                class="client-selector"
                v-model="clientValue"
                :clearable="false"
                placeholder="Bitte Kunde wählen"
                :options="clientItems"
                :disableFuzzyMatching="true"
                :disabled="disabled || isBusy">
    </treeselect>
    <b-button variant="primary" size="sm" @click="onContinueButtonClicked" :disabled="disabled || isBusy" class="ml-1">
        {{ buttonText || $t('Webportal.Continue') }}
    </b-button>
  </div>
</template>

<script>
import AdministrationService from '@/services/AdministrationService';
import EventBus from "@/services/EventBus.js";
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    disabled: {type: Boolean, default: false},
    buttonText: {type: String, default: null}
  },

  data () {
    return {
      clientItems:    [],                   // Data items for client treeselect
      clientValue:    undefined,            // Selected client item
      clientSettings: undefined,
      isBusy:         false,
    }
  },

  computed: {
    ...mapGetters('clientData', ['clients', 'isClientReady' ]),
    ...mapGetters('auth', ['clientId']),
  },

  created() {
    this.getClientSettings();
  },

  watch: {
    isClientReady(newVal) {
      this.initializeControl(this.clients);
    }
  },

  methods: {
    initializeControl(structure) {
      this.clientSettings = window.location.pathname == '/cx' && (APP_TARGET !== 'lexus' || APP_TARGET !== 'demov3')
        ? structure.filter(x => x.CxClient == true)
        : structure;

      this.initializeClientSelection(this.clientSettings);
      this.isBusy = false;

      if (this.clientId) {
        this.clientValue = this.clientId;
        this.onContinueButtonClicked();
      }

      if (!this.clientValue && this.clientSettings && this.clientSettings.length > 0) {
        let firstClient = this.clients.length > 0 ? this.clientItems[0] : undefined;
        this.clientValue = firstClient ? firstClient.id : undefined;
      }
    },

    getClientSettings() {
      this.isBusy = true;
      if (!this.isClientReady) return;

      if (this.clients && this.clients.length > 0) {
        this.initializeControl(this.clients);
        return;
      }

      AdministrationService.getClientSettings(null)
        .then(response => {
          this.initializeControl(response.data);
        })
        .catch(error => {
          console.warn("Error while receiving client settings: " + error);
          this.isBusy = false;
        });
    },

    initializeClientSelection(settings) {
      if (settings != null) {
        this.clientItems = settings.map(x => {
          return { id: x.ClientId, label: x.ClientName };
        });
      }
      EventBus.$emit('client-collection-changed', [...this.clientItems]);
    },

    onContinueButtonClicked() {
      var eventRetVal = undefined;

      if (this.clientValue) {
        eventRetVal = this.clientSettings.find(item => item.ClientId === this.clientValue);
      }

      if (!eventRetVal) {
        eventRetVal = this.clientSettings[0];
        this.clientValue = eventRetVal.ClientId;
      }

      this.$store.commit('auth/SET_CLIENT_ID', eventRetVal?.ClientId, { root: true });
      this.$emit('clientselectionchanged', eventRetVal);
      EventBus.$emit('client-selection-changed', eventRetVal);
    }
  }
}

</script>

<style lang="scss" scoped>
#clientSelector {
  max-width: 609px;
  // margin-left: 35px;
}

.client-selection {
  padding: 0rem 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
  padding: auto;
}

</style>
